'use client';

import { captureException, logger } from '@sentry/nextjs';
import { useEffect } from 'react';
import { ORIGIN } from '@/lib/config';
import ErrorLayout from './ui/errors';

export const metadata = {
  title: 'Campaign Starter Kit | Error',
  openGraph: {
    title: 'Campaign Starter Kit',
    description: 'Example OpenGraph description',
    url: 'https://campaign-starter-kit-eks.dev.csm.reviews',
    siteName: 'Campaign Starter Kit',
    images: [
      {
        url: `${ORIGIN}/og-image.png`,
        width: 800,
        height: 600,
      },
    ],
    locale: 'en_GB',
    type: 'website',
  },
};

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.info('User triggered test log', { log_source: 'sentry_test' });
    logger.error(error.message, {
      buildId: process.env.NEXT_BUILD_ID,
      digest: error.digest,
    });
    captureException(error);
  }, [error]);

  return <ErrorLayout title="Something went wrong" message={error.message} />;
}
